import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFr from '@angular/common/locales/fr';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarDateFormatter, CalendarModule, CalendarNativeDateFormatter, DateAdapter, DateFormatterParams } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InterventionComponent } from './components/intervention/intervention.component';
import { DayViewSchedulerComponent } from './components/my-calendar/day-view-scheduler.component';
import { MyCalendarComponent } from './components/my-calendar/my-calendar.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { ErrorComponent } from './error.component';
import { CoreData } from './tools/core-data/core-data';
import { DragDropDirective } from './tools/directive/drag-drop-directive';
import { PreventDoubleClickDirective } from './tools/directive/prevent-double-click.directive';
import { LoginGuard } from './tools/login-guard';
import { ChangeLetterDialog } from './tools/ui/change-letter-box/change-letter-box';
import { ChangeMapDialog } from './tools/ui/change-map-box/change-map-box';
import { ChangeProcessDialog } from './tools/ui/change-process-box/change-process-box';
import { ChangeZoneDialog } from './tools/ui/change-zone-box/change-zone-box';
import { ConfirmBoxDialog } from './tools/ui/confirm-box/confirm-box.component';
import { CustomSnackBarComponent } from './tools/ui/custom-snackbar/custom-snackbar.component';
import { ExoticCreationDialog } from './tools/ui/exotic-creation-box/exotic-creation-box';
import { LoadingTask } from './tools/ui/loading-task';
import { CustomEventDialog } from './tools/ui/cutom-event-box/custom-event-box';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { AgencyAndTechnicianSelectionDialog } from './tools/ui/agency-and-technician-selection-box/agency-and-technician-selection-box';
import { UserConfigurationComponent } from './components/user-configuration/user-configuration.component';
import {MatDividerModule} from '@angular/material/divider';
import { UserConfigurationDialog } from './tools/ui/user-configuration-box/user-configuration-box';
import { MatChipsModule } from '@angular/material/chips';
import { NextStrategyDialog } from './tools/ui/next-strategy-box/next-strategy-box';
import { DrawingMapToolComponent } from './components/drawing-map-tool/drawing-map-tool.component';

class CustomDateFormatter extends CalendarNativeDateFormatter {
    public override dayViewHour({ date, locale }: DateFormatterParams): string {
        return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: 'numeric' }).format(date);
    }
}

@NgModule({
    declarations: [
        AppComponent,
        ErrorComponent,
        NavMenuComponent,
        PreventDoubleClickDirective,
        MyCalendarComponent,
        InterventionComponent,
        RedirectComponent,
        DragDropDirective,
        ConfirmBoxDialog,
        CustomSnackBarComponent,
        ExoticCreationDialog,
        ChangeLetterDialog,
        ChangeMapDialog,
        ChangeZoneDialog,
        ChangeProcessDialog,
        DayViewSchedulerComponent,
        CustomEventDialog,
        AgencyAndTechnicianSelectionDialog,
        UserConfigurationComponent,
        UserConfigurationDialog,
        NextStrategyDialog,
        DrawingMapToolComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule,
        MatIconModule,
        MatButtonToggleModule,
        MatButtonModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatDialogModule,
        MatSnackBarModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatSidenavModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatChipsModule,
        FlexLayoutModule,
        MatDividerModule,
        NgxMatTimepickerModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        })],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        // { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
        { provide: CalendarDateFormatter, useClass: CustomDateFormatter },
        CoreData,
        LoadingTask,
        LoginGuard,
        DatePipe,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
export class AppModule { }

registerLocaleData(localeFr, 'fr', localeFrExtra);